import React from 'react';
import WorkplaceSettings from './WorkplaceSettings';
import styles from './GeneralSettings.module.scss';
import OrganisationSettings from './OrganisationSettings';
import UserSettings from './UserSettings';
import OrganizationalHierarchySettings from './OrganisationHierarchy';
import SecurityRoles from './SecurityRoles';
import PartnerSettings from './PartnerSettings';

type GeneralSettingsProps = {
	inFocus: 'organization' | 'workplace' | 'user' | 'organizational_hierarchy' | 'security_role' | 'partners' | null;
	setInFocus: (focus: 'organization' | 'workplace' | 'user' | 'organizational_hierarchy' | 'security_role' | 'partners' | null) => void;
};

const GeneralSettings: React.FC<GeneralSettingsProps> = ({ inFocus, setInFocus }) => {
	const handleFocusChange = (
		focus:
			| 'organization'
			| 'workplace'
			| 'user'
			| 'organizational_hierarchy'
			| 'security_role'
			| 'partners'
			| null
	) => {
		setInFocus(focus);
	};

	return (
		<div className={styles.generalSettingsContainer}>
			{(inFocus === null || (inFocus && inFocus === 'organization')) && (
				<OrganisationSettings handleFocusChange={handleFocusChange} />
			)}
			{(inFocus === null || (inFocus && inFocus === 'workplace')) && (
				<WorkplaceSettings handleFocusChange={handleFocusChange} inFocus={inFocus} />
			)}
			{(inFocus === null || (inFocus && inFocus === 'user')) && (
				<UserSettings handleFocusChange={handleFocusChange} />
			)}
			{(inFocus === null || (inFocus && inFocus === 'organizational_hierarchy')) && (
				<OrganizationalHierarchySettings handleFocusChange={handleFocusChange} inFocus={inFocus} />
			)}
			{(inFocus === null || (inFocus && inFocus === 'security_role')) && (
				<SecurityRoles handleFocusChange={handleFocusChange} inFocus={inFocus} />
			)}
			{(inFocus === null || (inFocus && inFocus === 'partners')) && (
				<PartnerSettings handleFocusChange={handleFocusChange} />
			)}
		</div>
	);
};

export default GeneralSettings;
